import { gql } from '@apollo/client';

export default gql`
  mutation stopPositioningSession($sessionId: UUID!, $bracelets: [String!]!) {
    stopPositioningSession(sessionId: $sessionId, bracelets: $bracelets)
  }
`;
